import {useState} from "react"

export default function useIndex(total) {
    const [current, setCurrent] = useState(0)
    return { setCurrent, current: `${current === 0 ? 1 : Math.ceil((current * total))} / ${total}` }
}